document.addEventListener('DOMContentLoaded', function () {
    var passwordField = document.getElementById('account_password');
    var passwordField2 = document.getElementById('password2');

    if (passwordField) {
        var wrapper = passwordField.closest('#account_password_field');

        if (wrapper) {
            var toggleBtn = document.createElement('button');
            toggleBtn.setAttribute('type', 'button');
            toggleBtn.setAttribute('id', 'toggle-password');
            toggleBtn.setAttribute('style', 'all:unset;position:absolute;right:20px;top:48px;z-index:2;');
            toggleBtn.innerHTML = '<svg role="presentation" class="login__icon"><use xlink:href="#eye"></use></svg>';

            wrapper.appendChild(toggleBtn);

            toggleBtn.addEventListener('click', function () {
                var type = passwordField.getAttribute('type') === 'password' ? 'text' : 'password';
                passwordField.setAttribute('type', type);
            });

            // Ensure wrapper has relative position so absolute works
            wrapper.style.position = 'relative';
        }
    }

    if (passwordField2) {
        var wrapper = passwordField2.closest('.form-row-wide');

        if (wrapper) {
            var toggleBtn = document.createElement('button');
            toggleBtn.setAttribute('type', 'button');
            toggleBtn.setAttribute('id', 'toggle-password2');
            toggleBtn.setAttribute('style', 'all:unset;position:absolute;right:20px;top:48px;z-index:2;');
            toggleBtn.innerHTML = '<svg role="presentation" class="login__icon"><use xlink:href="#eye"></use></svg>';

            wrapper.appendChild(toggleBtn);

            toggleBtn.addEventListener('click', function () {
                var type = passwordField2.getAttribute('type') === 'password' ? 'text' : 'password';
                passwordField2.setAttribute('type', type);
            });

            // Ensure wrapper has relative position so absolute works
            wrapper.style.position = 'relative';
        }
    }
});